import React from 'react'
import { flowRight } from 'lodash'
import { withTranslationCustom } from 'lib/i18next'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { PropTypes } from 'prop-types'

import InactiveAdMessage from 'components/Ads/InactiveAdMessage/InactiveAdMessage'
import ControlledModal from 'components/Modal/ControlledModal'

const InactiveAdModal = ({ vertical, adId }) => {
    return (
        <ControlledModal
            name="inactive-ad-modal"
            context="inactiveAdModal"
            requireUserInput={false}
            closeOnRouteChange={false}
        >
            {(modalProps) => (
                <InactiveAdMessage adId={adId} vertical={vertical} />
            )}
        </ControlledModal>
    )
}

InactiveAdModal.propTypes = {
    adId: PropTypes.string.isRequired,
}

export default flowRight(
    withErrorBoundaryNoRender,
    withTranslationCustom('makeOffer'),
)(InactiveAdModal)
